<template>
    <div class="sub">
        <!-- 楼层标题 -->
        <div class="sub_title">
            <div class="sub_title_content">
                <span class="sub_title_border"></span>
                <span class="sub_title_content_index">{{ title || "" }}</span>
                <span class="sub_title_content_text">{{ subTitle || "" }}</span>
            </div>
		</div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex"

    export default {
        name: "sub-title",
        components: {
            // CargoItem
            // CargoNormal,
        },
        props: {
            // config: {
            //     type: Object,
            //     required: false,
            // },
			title: {
			    type: String,
			    required: false,
			},
			subTitle: {
			    type: String,
			    required: false,
			},
        },
        data() {
            return {
                
            }
        },
        created() {
        },
        computed: {
            // ...mapGetters(["defaultGoodsImage"])
        },
        methods: {
            
        },
        watch: {
            config: {
                handler: function(e) {
                },
                immediate: true,
                deep: true
            }
        }
    }
</script>

<style lang="scss" scoped>
    .sub {
        &_title {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding-right: 20px;
            &_border {
                display: inline-block;
                width: 5px;
                height: 28px;
                background-color: $base-color;
                margin-right: 12px;
                vertical-align: top;
            }
        
            &_content {
                font-size: 20px;
                padding-top: 10px;
                padding-bottom: 10px;
                height: 48px;
                line-height: 28px;
                // border-bottom: 1px solid transparentize($color: $ns-text-color-black, $amount: 0.9);
        		box-sizing: border-box;
        
                &_index {
                    display: inline-block;
                    color: $ns-text-color-black;
                    padding-right: 8px;
                    font-weight: 600;
                }
        
                &_text {
        			font-weight: 600;
        			display: inline-block;
                    color: $base-color;
                }
            }
            .other-title {
                a {
                    color: #838383;
        
                    i {
                        font-size: 14px;
                    }
        			
        			&:hover {
        				color: $base-color;
        			}
                }
            }
        }
    }
</style>
